"use client";

import { Button, type ButtonProps } from "./button";
import { cn } from "./lib/utils";

interface ShinyButtonProps extends ButtonProps {
	glowClassName?: string;
}

export function ShinyButton({
	className,
	children,
	glowClassName,
	...props
}: ShinyButtonProps) {
	return (
		<div className="relative">
			<div
				className={cn(
					"absolute -inset-[2px] rounded-lg bg-gradient-to-r from-purple-500 via-cyan-300 to-emerald-400 opacity-75 blur-lg transition-all",
					"group-hover:opacity-100 group-hover:blur-xl",
					glowClassName,
				)}
			/>

			<Button className={cn("relative group", className)} {...props}>
				{children}
			</Button>
		</div>
	);
}
